import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { FormControl, Input, NativeSelect } from '@mui/material'
import { memo } from 'react'
import { getThemeSpacing } from '../../../styles/appTheme'
import { palette } from '../../../styles/colors'
import { APP_FONT } from '../../../theme'

const formStyles = css({
    flex: 'auto',
    maxWidth: '45%',
    '& label+div': {
        marginTop: getThemeSpacing(0.25),
    },
    '& select > option': {
        backgroundColor: palette.newsHeaderBackground + '!important',
    },
} as any)
const selectStyles = css({
    fontSize: '0.8rem',
    fontFamily: APP_FONT,
})

const Label = styled('label')({
    fontSize: '0.725rem',
    color: palette.drawerLabel,
})

interface ISelectMFC {
    value: string
    inputLabel: string
    selectOptions: object
    disabled?: boolean
    styleOverrides?: any
    onSelect(selected: any): void
    optionsRenderer([key, value]): React.ReactNode
}

const SelectMFC = memo((props: ISelectMFC) => {
    const {
        value = '',
        inputLabel,
        selectOptions,
        onSelect,
        optionsRenderer,
        styleOverrides,
        disabled,
    } = props

    const handleChange = ({ target: { value } }) => {
        onSelect(value)
    }

    const categoryText = inputLabel.toLowerCase().replace(/ /g, '')
    const categoryLabel = `${categoryText}-native-label-placeholder`

    return (
        <FormControl css={formStyles} style={styleOverrides}>
            <Label htmlFor={categoryLabel}>{inputLabel}</Label>
            <NativeSelect
                css={selectStyles}
                input={<Input name={categoryText} id={categoryLabel} />}
                onChange={handleChange}
                value={value}
                disabled={disabled}
            >
                {Object.entries(selectOptions).map(optionsRenderer)}
            </NativeSelect>
        </FormControl>
    )
})

export default SelectMFC
